<template>
  <div>
    <!-- Pet Care -->
    <tag-label-group v-if="serviceItems.petCare.length" :items="serviceItems.petCare" class="mt-16" />

    <!-- Child Care -->
    <tag-label-group v-if="isChildCare && serviceItems.childCare.length" :items="serviceItems.childCare" class="mt-16" />

    <!-- Companion Care -->
    <template
      v-if="
        serviceItems.companionCare.general.length ||
        serviceItems.companionCare.individualized.length ||
        serviceItems.companionCare.health.length
      "
    >
      <tag-label-group
        v-if="serviceItems.companionCare.general.length"
        :items="serviceItems.companionCare.general"
        class="mt-16"
        title="General services"
      />
      <tag-label-group
        v-if="serviceItems.companionCare.individualized.length"
        :items="serviceItems.companionCare.individualized"
        class="mt-16"
        title="Individualized services"
      />
      <tag-label-group
        v-if="serviceItems.companionCare.health.length"
        :items="serviceItems.companionCare.health"
        class="mt-16"
        title="Health & medical services"
      />
    </template>

    <!-- Housekeeping -->
    <tag-label-group v-if="serviceItems.housekeeping.length" :items="serviceItems.housekeeping" class="mt-16" />
  </div>
</template>

<script lang="ts">
import TagLabelGroup from '@/components/tag_label_group/TagLabelGroup.vue';
import {
  getServiceFields,
  ServiceDisplay,
  mapPetCareServices,
  mapChildCareServices,
  mapCompanionCareServices,
  mapHousekeepingServices,
  ChildCareServices,
} from '../../__types__/ServiceTypes';
import { FormattedCareType, isChildCare } from '../../__types__/CareTypes';

interface CompanionCareItems {
  general: ServiceDisplay[];
  individualized: ServiceDisplay[];
  health: ServiceDisplay[];
}

interface ServiceItems {
  petCare: ServiceDisplay[];
  childCare: ServiceDisplay[];
  companionCare: CompanionCareItems;
  housekeeping: ServiceDisplay[];
}

export default {
  name: 'ProfileServices',
  components: { TagLabelGroup },
  props: {
    careType: {
      type: String as () => FormattedCareType,
      required: true,
    },
    services: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isChildCare: isChildCare(this.careType),
    };
  },
  computed: {
    serviceItems(): ServiceItems {
      const formattedServices = getServiceFields(this.services, this.careType);
      const childCareServices = (formattedServices[this.careType] || formattedServices.childCare) as ChildCareServices;
      const companionCareServices = formattedServices.companionCare;
      const housekeeping = mapHousekeepingServices(formattedServices.housekeeping || {});
      console.log('careType:', this.careType);
      console.log('formattedServices:', formattedServices);
      console.log('childCareServices:', childCareServices);
      console.log('Housekeeping services:', housekeeping);
      return {
        petCare: mapPetCareServices(formattedServices.petCare || {}),
        childCare: mapChildCareServices(childCareServices || {}),
        companionCare: {
          general: mapCompanionCareServices(companionCareServices || {}, 'general'),
          individualized: mapCompanionCareServices(companionCareServices || {}, 'individualized'),
          health: mapCompanionCareServices(companionCareServices || {}, 'health'),
        },
        housekeeping,
      };
    },
  },
};
</script>
